module.exports = __webpack_public_path__ + "static/media/bff4.a08447cf.png";